import React from 'react';
import memoize from 'fast-memoize';

export const textFieldErrorPropsApollo = memoize(
  (apolloMutateData: any, field: string) => {
    const ret: { error?: boolean; helperText?: string } = {};
    try {
      const outerKey = Object.keys(apolloMutateData)[0];
      const { errors } = apolloMutateData[outerKey];
      for (let i = 0; i < errors.length; i++) {
        const error = errors[i];
        if (error.path[1] === field) {
          ret.error = true;
          ret.helperText = error.message;
          break;
        }
      }
    } catch {}
    return ret;
  }
);

interface Error {
  message: string;
  path: string[];
}

export const textFieldErrorPropsApolloV2 = memoize(
  (errors: Error[], field: string) => {
    const ret: { error?: boolean; helperText?: string } = {};
    try {
      for (let i = 0; i < errors.length; i++) {
        const error = errors[i];
        if (error.path[1] === field) {
          ret.error = true;
          ret.helperText = error.message;
          break;
        }
      }
    } catch {}
    return ret;
  }
);

export const textFieldErrorsFromNormalized = (errors: any, field: string) => {
  if (!errors[field])
    return {
      error: false,
      helperText: '',
    };
  const helperText = errors[field].map((error: string, index: number) => (
    <span style={{ display: 'block' }} key={index}>
      {error}
    </span>
  ));
  return {
    error: true,
    helperText,
  };
};
